import { ReactElement } from 'react';
import PageHeader from 'shared/components/PageHeader';
import PolicySetting from './ProxySetting';
import { Box } from '@mui/material';

const ProxyPage = (): ReactElement => (
  <>
    <PageHeader
      title="Proxy Settings"
      description="Configure proxy behavior for your organization."
      noPadding
    />
    <Box className="policy-setting">
      <PolicySetting />
    </Box>
  </>
);

export default ProxyPage;
